import { apiClient } from './client';

export type BrandScanExtensionMode = 'internal_only' | 'fallback' | 'extension_only';

export interface GeneralConfig {
  browser_engine?: 'patchright' | 'playwright';
  brand_scan_extension_mode?: BrandScanExtensionMode;
  brand_scan_extension_wait_seconds?: number;
  brand_scan_preferred_worker_ids?: string[];
  brand_scan_strict_worker_routing?: boolean;
}

export const generalConfigApi = {
  getConfig: async (): Promise<GeneralConfig> => {
    const response = await apiClient.get<GeneralConfig>('/api/v1/scraper/config/general/');
    return response.data;
  },

  updateConfig: async (config: GeneralConfig): Promise<void> => {
    await apiClient.put('/api/v1/scraper/config/general/', config);
  },
};
